module.exports = __webpack_public_path__ + "img/foto2.26c90733.jpg";